
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";

const getColumns = (
) => {
  const renderLink = (id, name, content) => {
    if (name === 'id') {
      return (
        <Link to={`/issues/${id}`}>
          {content} <EditOutlined />
        </Link>
      );
    }
    return content;
  };

  return [
    {
      title: "ID",
      dataIndex: "id",
      sortable: true,
      searchable: true,
      search_method: "eq",
      width: 350,
      render: (_, { id }) => renderLink(id, "id", id),
    },
    {
      title: "Nazwa ulicy",
      dataIndex: "client_street",
      sortable: true,
      searchable: true,
      search_method: "matches",
      render: (_, { id, client_street }) =>
        renderLink(id, "client_street", client_street),
    },
    {
      title: "Numer budynku",
      dataIndex: "client_building_number",
      sortable: true,
      searchable: true,
      width: 130,
      search_method: "matches",
      render: (_, { id, client_building_number }) =>
        renderLink(id, "client_building_number", client_building_number),
    },
    {
      title: "Numer mieszkania",
      dataIndex: "client_apartment_number",
      sortable: true,
      searchable: true,
      width: 130,
      search_method: "matches",
      render: (_, { id, client_apartment_number }) =>
        renderLink(id, "client_apartment_number", client_apartment_number),
    },
  ];
};

export default getColumns;
